export const LANDING_MAX_CONTENT_WIDTH_PX = 1440

export const LANDING_INLINE_PADDINGS = [5, 5, 11]

// legacy
export const PADDING_X = LANDING_INLINE_PADDINGS
export const PX_BLUEPRINT = LANDING_INLINE_PADDINGS
export const PY_BLUEPRINT = [36, 36, 40, 60]
export const BORDER_RADIUS = 88
export const BLUEPRINT_WIDTH = LANDING_MAX_CONTENT_WIDTH_PX
export const CONTENT_WIDTH_WIDE = 1600
export const CONTENT_WIDTH = 1232
export const POPUP_DELAY = 500
